module.exports = __webpack_public_path__ + "static/assets/69648d13ef5533a41d1f0fda3ef5f136.svg";